import React from 'react'
import { SvgIcon, SxProps } from '@mui/material'

interface Props {
  sx?: SxProps
  [prop: string]: any
}

export const ReplyIcon = ({ sx, ...props }: Props) => (
  <SvgIcon
    viewBox="0 0 24 24"
    sx={{ color: 'secondary.main', ...sx }}
    {...props}
  >
    <path d="M4.08 10.12a1 1 0 0 1 .2-.33l3-3a1 1 0 1 1 1.43 1.42L7.4 9.5H17a3 3 0 0 1 3 3v4a1 1 0 1 1-2 0v-4a1 1 0 0 0-1-1H7.4l1.3 1.29a1 1 0 0 1-.7 1.72 1 1 0 0 1-.71-.3l-3-3a1 1 0 0 1-.21-.33 1 1 0 0 1 0-.76Z" />
  </SvgIcon>
)

ReplyIcon.defaultProps = {
  sx: null,
}

export const ReplySmallIcon = ({ sx, ...props }: Props) => (
  <SvgIcon
    viewBox="0 0 20 20"
    sx={{ color: 'secondary.main', ...sx }}
    {...props}
  >
    <path
      d="M3.39544 8.43316C3.4351 8.33087 3.49458 8.23742 3.57044 8.15816L6.07044 5.65816C6.14814 5.58046 6.24038 5.51883 6.3419 5.47678C6.44342 5.43473 6.55223 5.41309 6.66211 5.41309C6.88403 5.41309 7.09686 5.50124 7.25378 5.65816C7.33147 5.73586 7.39311 5.8281 7.43516 5.92962C7.47721 6.03114 7.49885 6.13995 7.49885 6.24983C7.49885 6.47175 7.4107 6.68458 7.25378 6.8415L6.17044 7.9165H14.1621C14.8252 7.9165 15.461 8.17989 15.9299 8.64873C16.3987 9.11757 16.6621 9.75345 16.6621 10.4165V13.7498C16.6621 13.9708 16.5743 14.1828 16.418 14.3391C16.2618 14.4954 16.0498 14.5832 15.8288 14.5832C15.6078 14.5832 15.3958 14.4954 15.2395 14.3391C15.0832 14.1828 14.9954 13.9708 14.9954 13.7498V10.4165C14.9954 10.1955 14.9076 9.98352 14.7514 9.82724C14.5951 9.67096 14.3831 9.58316 14.1621 9.58316H6.17044L7.25378 10.6582C7.33188 10.7356 7.39388 10.8278 7.43618 10.9293C7.47849 11.0309 7.50027 11.1398 7.50027 11.2498C7.50027 11.3598 7.47849 11.4688 7.43618 11.5703C7.39388 11.6719 7.33188 11.764 7.25378 11.8415C7.17631 11.9196 7.08414 11.9816 6.98259 12.0239C6.88104 12.0662 6.77212 12.088 6.66211 12.088C6.5521 12.088 6.44318 12.0662 6.34163 12.0239C6.24008 11.9816 6.14791 11.9196 6.07044 11.8415L3.57044 9.3415C3.49458 9.26224 3.4351 9.16879 3.39544 9.0665C3.31209 8.86361 3.31209 8.63605 3.39544 8.43316Z"
      fill="#55A6FF"
    />
  </SvgIcon>
)

ReplySmallIcon.defaultProps = {
  sx: null,
}
